export default {
  section1: [
    {
      name: "draftLevel",
      label: "Please select the level for which you want to apply",
      label_lang: "OnbrdInterimUplevelHeader",
      vertical: true,
      type: "radiogroup",
      required: true,
      key: "pg1_1",
      useLabel: true,
      radios: [
        {
          label: "Certified",
          value: "Certified",
          type: "Radio",
          key: "pg1_2",
          useLabel: true,
        },
        {
          label: "Gold",
          value: "Gold",
          type: "Radio",
          key: "pg1_3",
          useLabel: true,
        },
      ],
      actions: [
        {
          fieldName: "draftLevel",
          func: "draftLevelAction",
        },
      ],
    },
  ],
  section2: [
    {
      name: "iCertify",
      label: "I certify that I am either :",
      label_lang: "i_certify",
      type: "checkbox",
      useLabel: true,
      renderLabel: false,
      required: true,
      fieldLableProps: { position: "left" },
      key: "pg2_1",
    },
  ],
  section3: [
    {
      name: "membershipId",
      label: "Membership ID",
      label_lang: "OnbrdProfileMembershipId",
      type: "textfield",
      required: true,
      disabled: true,
      validator: "isString",
      key: "pg3_1",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },

    {
      name: "anniversaryDate",
      label: "Contract Start Date",
      label_lang: "OnbrdProfileContractStart",
      type: "textfield",
      required: true,
      disabled: true,
      validator: "isString",
      key: "pg4_1",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "tradingName",
      label: "Trading Name",
      label_lang: "OnbrdProfileTradingName",
      type: "textfield",
      maxLength: 80,
      placeholder: "Enter your trading name",
      key: "pg3_3",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "preferredDistributor",
      label: "Preferred Distributor",
      label_lang: "OnbrdProfilePreferredDistributor",
      type: "textfield",
      maxLength: 255,
      placeholder: "Enter your preferred distributor",
      key: "pg3_4",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "companyType",
      label: "Company Type(select all that apply)*",
      label_lang: "OnbrdProfileCompType",
      type: "select",
      required: true,
      multiple: true,
      validator: "isValidList",
      placeholder: "Select company type(s)",
      key: "pg3_5",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
      options: [
        {
          label: "Large Account Reseller (LAR)",
          value: "Large Account Reseller (LAR)",
        },
        {
          label: "Value Added Reseller (VAR)",
          value: "Value Added Reseller (VAR)",
        },
        {
          label: "Systems Integrator (SI)",
          value: "Systems Integrator (SI)",
        },
        {
          label: "Independent Software Vendor (ISV)",
          value: "Independent Software Vendor (ISV)",
        },
        {
          label: "Original Equipment Manufacturer (OEM)",
          value: "Original Equipment Manufacturer (OEM)",
        },
        {
          label: "Consulting Firm",
          value: "Consulting Firm",
        },
        {
          label: "Service(s) Provider",
          value: "Service(s) Provider",
        },
        {
          label: "Authorized Distributor",
          value: "Authorized Distributor",
        },
        {
          label: "Online Retailer",
          value: "Online Retailer",
        },
        {
          label: "Retail Partner",
          value: "Retail Partner",
        },
      ],
    },
  ],
  section4: [
    {
      name: "name",
      label: "Company Name *",
      label_lang: "OnbrdProfileFullCompName",
      type: "textfield",
      maxLength: 255,
      required: true,
      disabled: true,
      placeholder: "Enter your company name",
      validator: "isString",
      key: "pg4_2",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "contractEndDate",
      label: "Contract End Date",
      label_lang: "OnbrdProfileContractEnd",
      type: "textfield",
      required: true,
      disabled: true,
      validator: "isString",
      key: "pg3_2",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "bizRegistrationNum",
      label: "Business Registration Number",
      label_lang: "OnbrdProfileBRN",
      type: "textfield",
      maxLength: 80,
      placeholder: "Enter your business registartion number",
      key: "pg4_3",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "dateFounded",
      label: "Year Established *",
      label_lang: "OnbrdProfileYrIncorp",
      type: "textfield",
      maxLength: 4,
      required: true,
      validator: "isYear",
      placeholder: "Enter your year established",
      key: "pg4_4",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
  ],
  section12: [
    {
      name: "membershipId",
      label: "Membership ID",
      label_lang: "OnbrdProfileMembershipId",
      type: "textfield",
      required: true,
      disabled: true,
      validator: "isString",
      key: "pg3_1",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "parentMembershipId",
      type: "textfield",
      label: "Parent Membership ID",
      label_lang: "OnbrdProfileParentMembershipId",
      key: "pg1sec1_2",
      required: false,
      useLabel: true,
      disabled: true,
      validator: "isString",
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "anniversaryDate",
      label: "Contract Start Date",
      label_lang: "OnbrdProfileContractStart",
      type: "textfield",
      required: true,
      disabled: true,
      validator: "isString",
      key: "pg4_1",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "contractEndDate",
      label: "Contract End Date",
      label_lang: "OnbrdProfileContractEnd",
      type: "textfield",
      required: true,
      disabled: true,
      validator: "isString",
      key: "pg3_2",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "tradingName",
      label: "Trading Name",
      label_lang: "OnbrdProfileTradingName",
      type: "textfield",
      maxLength: 80,
      placeholder: "Enter your trading name",
      key: "pg3_3",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "preferredDistributor",
      label: "Preferred Distributor",
      label_lang: "OnbrdProfilePreferredDistributor",
      type: "textfield",
      maxLength: 255,
      placeholder: "Enter your preferred distributor",
      key: "pg3_4",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "companyType",
      label: "Company Type(select all that apply)*",
      label_lang: "OnbrdProfileCompType",
      type: "select",
      required: true,
      multiple: true,
      validator: "isValidList",
      placeholder: "Select company type(s)",
      key: "pg3_5",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
      options: [
        {
          label: "Large Account Reseller (LAR)",
          value: "Large Account Reseller (LAR)",
        },
        {
          label: "Value Added Reseller (VAR)",
          value: "Value Added Reseller (VAR)",
        },
        {
          label: "Systems Integrator (SI)",
          value: "Systems Integrator (SI)",
        },
        {
          label: "Independent Software Vendor (ISV)",
          value: "Independent Software Vendor (ISV)",
        },
        {
          label: "Original Equipment Manufacturer (OEM)",
          value: "Original Equipment Manufacturer (OEM)",
        },
        {
          label: "Consulting Firm",
          value: "Consulting Firm",
        },
        {
          label: "Service(s) Provider",
          value: "Service(s) Provider",
        },
        {
          label: "Authorized Distributor",
          value: "Authorized Distributor",
        },
        {
          label: "Online Retailer",
          value: "Online Retailer",
        },
        {
          label: "Retail Partner",
          value: "Retail Partner",
        },
      ],
    },
  ],
  section13: [
    {
      name: "name",
      label: "Company Name *",
      label_lang: "OnbrdProfileFullCompName",
      type: "textfield",
      maxLength: 255,
      required: true,
      disabled: true,
      placeholder: "Enter your company name",
      validator: "isString",
      key: "pg4_2",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "level",
      type: "textfield",
      label: "Partner level",
      label_lang: "OnbrdProfilePartnerLevel",
      key: "pg1sec1_2",
      required: false,
      useLabel: true,
      disabled: true,
      validator: "isString",
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "specialisation",
      type: "textfield",
      label: "Specialization",
      label_lang: "OnbrdProfileSplzn",
      key: "pg1sec20_2",
      required: false,
      useLabel: true,
      disabled: true,
      validator: "isString",
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "additionalLicenses",
      type: "textfield",
      label: "# Additional licenses",
      label_lang: "OnbrdProfileAddLicenses",
      key: "pg1sec20_1",
      required: false,
      useLabel: true,
      disabled: true,
      gridRowProps: {},
      gridColumnProps: {},
    },

    {
      name: "bizRegistrationNum",
      label: "Business Registration Number",
      label_lang: "OnbrdProfileBRN",
      type: "textfield",
      maxLength: 80,
      placeholder: "Enter your business registartion number",
      key: "pg4_3",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "dateFounded",
      label: "Year Established *",
      label_lang: "OnbrdProfileYrIncorp",
      type: "textfield",
      maxLength: 4,
      required: true,
      validator: "isYear",
      placeholder: "Enter your year established",
      key: "pg4_4",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
  ],
  section5: [
    {
      name: "billingStreet",
      label: "Street *",
      label_lang: "OnbrdProfileStreet",
      type: "textfield",
      maxLength: 255,
      required: true,
      validator: "isString",
      placeholder: "Enter your address",
      key: "pg3_7",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "billingState",
      label: "State/Province *",
      label_lang: "OnbrdProfileState",
      type: "textfield",
      maxLength: 20,
      required: true,
      validator: "isString",
      placeholder: "State/Province",
      key: "pg3_8",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
      actions: [
        {
          fieldName: "billingCountry",
          func: "setStateType",
        },
      ],
    },
    {
      name: "countryLable",
      label: "Country *",
      label_lang: "OnbrdProfileCountry",
      type: "textfield",
      disabled: true,
      validator: "isString",
      key: "pg3_9",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
      actions: [
        {
          fieldName: "billingCountry",
          func: "setCountryLabel",
        },
      ],
    },
  ],
  section6: [
    {
      name: "billingCity",
      label: "City *",
      label_lang: "OnbrdProfileCity",
      type: "textfield",
      maxLength: 40,
      required: true,
      validator: "isString",
      placeholder: "City",
      key: "pg3_10",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "billingPostalCode",
      label: "Postal Code *",
      label_lang: "OnbrdProfilePostCode",
      type: "textfield",
      maxLength: 20,
      required: true,
      validator: "isString",
      placeholder: "Postal Code",
      key: "pg3_11",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
  ],
  section7: [
    {
      name: "companyPhone",
      label: "Primary Phone *",
      label_lang: "OnbrdProfilePrimPhone",
      type: "textfield",
      required: true,
      validator: "isValidPhoneNumber",
      placeholder: "Enter the primary phone number",
      key: "pg3_12",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "companyEmail",
      label: "Company E-main Addres *",
      label_lang: "comp_email_address",
      type: "textfield",
      required: true,
      validator: "isEmailDomain",
      placeholder: "Enter your company e-mail address",
      key: "pg3_13",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "secondaryUrl",
      label: "Secondary Website",
      label_lang: "OnbrdProfileSecondaryURL",
      type: "textfield",
      maxLength: 255,
      validator: "isValidWebsite",
      placeholder: "Enter a secondary website URL",
      key: "pg3_14",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
  ],
  section8: [
    {
      name: "fax",
      label: "Fax",
      label_lang: "OnbrdProfilePrimFax",
      type: "textfield",
      placeholder: "Enter the fax machine number",
      key: "pg3_15",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "primaryUrl",
      label: "Website URL *",
      label_lang: "OnbrdProfilePrimURL",
      type: "textfield",
      maxLength: 255,
      required: true,
      validator: "isValidWebsite",
      placeholder: "Enter your company website URL",
      key: "pg3_16",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
  ],
  section9: [
    {
      name: "appearInPartnerFinder",
      label: "List in Partner Finder?",
      label_lang: "ConsolePartnerAccountListPartnerFinder",
      type: "checkbox",
      renderLabel: false,
      useLabel: true,
      key: "pg3_1",
    },
  ],
  section10: [
    {
      name: "prefix",
      label: "Prefix",
      label_lang: "OnbrdContactPrefix",
      type: "textfield",
      maxLength: 10,
      placeholder: "Enter the prefix",
      validator: "prefixContactField",
      key: "pg1ac1",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "suffix",
      label: "Suffix/Title",
      label_lang: "OnbrdContactTitle",
      type: "textfield",
      maxLength: 10,
      placeholder: "Enter the suffix/title",
      validator: "suffixContactField",
      key: "pg1ac2",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "firstName",
      label: "First Name *",
      label_lang: "OnbrdContactFName",
      type: "textfield",
      maxLength: 40,
      required: true,
      validator: "isString",
      placeholder: "First name",
      key: "pg4_15",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "lastName",
      label: "Last Name *",
      label_lang: "OnbrdContactLName",
      type: "textfield",
      maxLength: 80,
      required: true,
      validator: "isString",
      placeholder: "Last name",
      key: "pg4_19",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "mainContactType",
      type: "textfield",
      label: "Main contact type",
      label_lang: "ConsolePartnerContactCType",
      placeholder: "Other",
      useLabel: true,
      key: "pg2sec1_5",
      disabled: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "active",
      type: "checkbox",
      label: "Active",
      label_lang: "ConsolePartnerConActive",
      useLabel: true,
      hide: true,
      renderLabel: false,
      fieldLableProps: { position: "left" },
      key: "pg2sec1_5",
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "certification",
      label: "Training Courses Completed(select all that apply)",
      type: "select",
      label_lang: "course_completed_ff",
      placeholder: "Select the course(s)",
      options: [
        {
          label: "Partner Code of Conduct",
          value: "Partner Code of Conduct",
        },
      ],
      multiple: true,
      key: "pg4_24",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
  ],
  section11: [
    {
      name: "phone",
      label: "Phone Number *",
      label_lang: "OnbrdContactPhone",
      type: "textfield",
      required: true,
      validator: "isValidPhoneNumber",
      placeholder: "Enter your phone number",
      key: "pg4_20",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "email",
      label: "E-mail Address *",
      label_lang: "OnbrdProfileContactEmail",
      type: "textfield",
      required: true,
      validator: "isEmailDomain",
      placeholder: "E-mail address",
      key: "pg4_16",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "jobRole",
      label: "Job Role *",
      label_lang: "OnbrdContactJRole",
      type: "select",
      required: true,
      validator: "isString",
      placeholder: "Select a job role",
      options: [
        {
          label: "Accounting",
          value: "Accounting",
        },
        {
          label: "Administration",
          value: "Administration",
        },
        {
          label: "Development",
          value: "Development",
        },
        {
          label: "Executive",
          value: "Executive",
        },
        {
          label: "Finance",
          value: "Finance",
        },
        {
          label: "Helpdesk Support",
          value: "Helpdesk Support",
        },
        {
          label: "IT",
          value: "IT",
        },
        {
          label: "Marketing",
          value: "Marketing",
        },
        {
          label: "Owner",
          value: "Owner",
        },
        {
          label: "Partner Specialist",
          value: "Partner Specialist",
        },
        {
          label: "PR/Communications",
          value: "PR/Communications",
        },
        {
          label: "Professional Services",
          value: "Professional Services",
        },
        {
          label: "Sales Representative",
          value: "Sales Representative",
        },
        {
          label: "Sales Management",
          value: "Sales Management",
        },
        {
          label: "System/Pre-sales Engineer",
          value: "System/Pre-sales Engineer",
        },
        {
          label: "Technical Support",
          value: "Technical Support",
        },
        {
          label: "Training",
          value: "Training",
        },
        {
          label: "Web Administration/Master",
          value: "Web Administration/Master",
        },
      ],
      key: "pg4_17",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
    {
      name: "preferredLanguage",
      label: "Primary Language *",
      label_lang: "OnbrdContactPrefLang",
      type: "select",
      required: true,
      validator: "isString",
      placeholder: "Select a language",
      options: [],
      key: "pg4_18",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
      actions: [
        {
          fieldName: "billingCountry",
          func: "languageAction",
        },
        {
          fieldName: "billingCountry",
          func: "setLanguageUR",
        },
      ],
    },
    {
      name: "additionalContactType",
      label: "Contact Type(select all that apply) *",
      type: "select",
      label_lang: "contact_type",
      required: true,
      validator: "isValidList",
      placeholder: "Select contact type(s)",
      options: [
        {
          label: "Lead Sales",
          value: "Lead Sales",
        },
        {
          label: "Lead Marketing",
          value: "Lead Marketing",
        },
        {
          label: "Lead Technical",
          value: "Lead Technical",
        },
        {
          label: "Sales Information",
          value: "Sales Information",
        },
        {
          label: "Marketing Information",
          value: "Marketing Information",
        },
        {
          label: "Technical Information",
          value: "Technical Information",
        },
        {
          label: "Security Information",
          value: "Security Information",
        },
        {
          label: "Events and Promotional Offers",
          value: "Events and Promotional Offers",
        },
        {
          label: "General Information",
          value: "General Information",
        },
        {
          label: "Standard User",
          value: "Standard User",
        },
      ],
      multiple: true,
      key: "pg4_22",
      useLabel: true,
      gridRowProps: {},
      gridColumnProps: {},
    },
  ],

  section15: [
    {
      name: "iAgree",
      label:
        "I HAVE READ, UNDERSTOOD, AND AGREED TO COMPLY WITH THE TERMS AND CONDITIONS INDICATED HEREIN AND REPRESENT AND WARRANT THAT I AM AUTHORIZED TO BIND THE RESELLER.",
      label_lang: "prog_agmt_checkbox",
      type: "checkbox",
      renderLabel: false,
      fieldLableProps: {
        position: "left",
        style: {
          width: "90%",
          float: "right",
        },
      },
      useLabel: true,
      key: "pg5_1",
      required: true,
    },
  ],
  section18: [
    {
      name: "appearInPartnerFinder",
      label: "List in Partner Finder?",
      label_lang: "ConsolePartnerAccountListPartnerFinder",
      type: "checkbox",
      useLabel: true,
      renderLabel: false,
      fieldLableProps: { position: "left" },
      displayLabel: { true: "Yes", false: "No" },
      key: "pg1eap8",
      gridRowProps: {},
      gridColumnProps: {},
    },
  ],
};
